import ThumborJS from "thumborjs";
import Link from "next/link";
const imageUrl = process.env.NEXT_PUBLIC_IMAGE_URL;
const thumborKey = process.env.NEXT_PUBLIC_THUMBOR_KEY;
const thumborUrl = process.env.NEXT_PUBLIC_THUMBOR_URL;

const App = ({ content, queryParam }) => {
  const getImageUrl = (src, width) => {
    return new ThumborJS(thumborUrl, thumborKey)
      .imgpath(src)
      .resize(width, 0)
      .filter("format(webp)")
      .genurl();
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 justify-center">
      {content?.map((content, index) => {
        const mobilePath = content?.imagepath_mobile?.replace(/\/uploads/g, "");
        const desktopPath = content?.imagepath_desktop?.replace(
          /\/uploads/g,
          "",
        );
        const mobileImage = getImageUrl(`${imageUrl}${mobilePath}`, 560);
        const desktopImage = getImageUrl(`${imageUrl}${desktopPath}`, 560);
        return (
          <Link
            key={`content-${index}`}
            prefetch={false}
            href={`all?filter_gender=${content?.product_tag}${
              queryParam ? `?${queryParam}` : ``
            }`}
          >
            <div className="relative w-full aspect-[560/211] sm:aspect-[1/1]">
              <picture>
                <source media="(min-width: 640px)" srcSet={desktopImage} />
                <img
                  src={mobileImage}
                  alt={content?.title_en}
                  loading="lazy"
                  decoding="async"
                  width={560}
                  height={211}
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </picture>
              <span className="absolute bottom-2 left-3 text-black text-lg font-bold ">{`${content.title_en}`}</span>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default App;
